import { useRef } from 'react';

export const useAnchors = qty => {
    const ref = useRef();
    return Array.from({ length: qty }, () => ref);
};
